import { Injectable, Signal } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from '../models/User';
import { GuestUser } from '../models/GuestUser';
import { Credentials } from '../models/Credentials';

export type Principal =
  | { kind: 'user'; user: User }
  | { kind: 'guest'; guestUser: GuestUser }
  | { kind: 'anonymous' };

@Injectable()
export abstract class AuthFacade {
  abstract readonly principal: Signal<Principal>;
  abstract readonly isAuthenticated: Signal<boolean>;
  abstract readonly isGuest: Signal<boolean>;

  abstract login(credentials: Credentials): Observable<void>;
  abstract logout(): void;
}
